module.exports = __webpack_public_path__ + "static/media/wordpress.ad28d74c.svg";